/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { EntityContext } from "cms/entity/context";
import { getEntityAttributeEditor } from "./get-entity-attribute-editor";

const EntityAttributeEditor = (props) => {
    
    const reference = props?.reference;
    const type = props?.type;
    const name = props?.name;
    const value = props?.value;
    const position = props?.position;
    
    // const { schema, entity, attr, updateAttribute } = useContext(EntityContext);
    
    const Editor = getEntityAttributeEditor(type);

    return (
        <div key={`${name}_${position}`} className="entity-attribute-editor">
            <Editor
                type={type}
                name={name}
                value={value}
                reference={reference}
            />
        </div>
    );
};

export { EntityAttributeEditor };
